var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrabajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31 11.552-11.595 5.135c-0.132 0.058-0.269 0.086-0.405 0.086v1.239c0 0.553-0.448 1-1 1h-4c-0.552 0-1-0.447-1-1v-1.243c-0.136 0-0.274-0.028-0.406-0.086l-11.594-5.131v12.448c-0 0.796 0.316 1.559 0.879 2.121 0.562 0.563 1.325 0.879 2.121 0.879h24c0.796 0 1.559-0.316 2.121-0.879 0.563-0.562 0.879-1.325 0.879-2.121v-12.448zm-14 2.448v3.012h-2v-3.012h2zm-10-9h-3c-0.796-0-1.559 0.316-2.121 0.879-0.563 0.562-0.879 1.325-0.879 2.121v1.365l12 5.311v-1.676c0-0.552 0.448-1 1-1h4c0.552-0 1 0.448 1 1v1.679l12-5.315v-1.364c0-0.796-0.316-1.559-0.879-2.121-0.562-0.563-1.325-0.879-2.121-0.879h-3v-1c0-1.657-1.343-3-3-3h-12c-1.657 0-3 1.343-3 3v1zm16-0h-14v-1c-0-0.552 0.448-1 1-1h12c0.552 0 1 0.448 1 1v1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrabajo);
export default __webpack_public_path__ + "static/media/trabajo.e759eb20a2bb1053aaeff8ad5c12e507.svg";
export { ForwardRef as ReactComponent };